import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { City } from "../../models/domains/pbm/state/city";
import { StateAcronym } from "../../models/domains/pbm/state/state-acronym";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { CityParser } from "../parsers/pbm/state/city.parser";
import { StateAcronymParser } from "../parsers/pbm/state/state-acronym.parser";
import { environment } from "src/environments/environment";
import { ZipCodeIntegrationParser } from "../parsers/pbm/beneficiary/zip-code-integration.parser";
import { ZipCodeIntegration } from "../../models/domains/pbm/state/zip-code-integration.model.ts";

@Injectable()
export class StateRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private stateAcronymParser: StateAcronymParser,
    private cityParser: CityParser,
    private zipCodeIntegrationParser: ZipCodeIntegrationParser,
  ) {}

  public async getStates(): Promise<StateAcronym[]> {
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.get(new BackendUrl("/api/states/acronyms"));
      return Promise.resolve(this.stateAcronymParser.parse(data));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getCityByStateAcronym(stateAcronym: StateAcronym): Promise<City[]> {
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.get(new BackendUrl("/api/states/cities/" + stateAcronym.getValue()));
      return Promise.resolve(this.cityParser.parse(data));
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async getZipCode(cep: string): Promise<ZipCodeIntegration> {
    try {
      const remoteGateway = this.remoteGatewayFactory.createRemoteGateway(environment.backendUrl);
      const data: any = await remoteGateway.get(new BackendUrl (`/api/adress/${cep}`));
      const zipCodeIntegration = await Promise.resolve(this.zipCodeIntegrationParser.parse(data));
      return zipCodeIntegration;
    } catch (error) {
      return await Promise.reject(this.zipCodeIntegrationParser.parse(error));
    }
  }
}
